import { Component, Inject, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { GroupService } from "../../shared/services/group/group.service";
import { Group } from "../../shared/interface/group";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

//add edit group name
@Component({
  selector: "group-dialog",
  templateUrl: "group.dialog.html"
})
export class GroupDialog implements OnDestroy {
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  groupForm: FormGroup;
  isSubmitted: number = 0;
  oldSection;  
  maxGroupId = 1;
  dashboardGroups = [];
  groupListSec = [];
  demoGraphicOption: false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    private groupService: GroupService,
    public dialogRef: MatDialogRef<GroupDialog>,
    private activatedRoute: ActivatedRoute) {
    this.dashboardGroups = data.groupList;
    this.groupListSec = data.groupListSec;    
    data = this.parseForm(data);
    this.demoGraphicOption = (data.demoGraphicOption === undefined ? false : data.demoGraphicOption);
    this.createForm(data);
  }

  //create group form
  createForm(data: Group) {
    this.groupForm = this.fb.group({
      dashboardId: data.dashboardId,
      groupId: data.groupId,
      isPredictive: (!data.isGeo && !data.isSection ? data.isPredictive : false),
      isSection: (!data.isPredictive && !data.isGeo ? data.isSection : false),
      parentId: (!data.isPredictive ? data.parentId : ""),
      groupName: [data.groupName, Validators.required],
      order: [data.order, Validators.pattern('[0-9]+')],
      isGeo: (!data.isPredictive && !data.isSection ? data.isGeo : false),
    });
  }

  parseForm(data) {
    this.maxGroupId = data.maxGroupId;
    if (data) {
      if (!(data.order > 0)) {
        // data.order = 1;
        data.order = this.maxGroupId + 1;
      }
      this.oldSection = data.isSection;
      if (!data.parentId) {
        data.parentId = "";
      }
      return data;
    }
    return {
      dashboardId: "",
      groupId: "",
      groupName: "",
      isPredictive: false,
      isSection: false,
      parentId: "",
      order: this.maxGroupId + 1,
      isGeo: false,
    };
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  onSubmit(form: any) {
    if (!this.groupForm.valid) {
      return;
    }
    this.isSubmitted = 1;
    //create group
    if (!form.groupId) {
      this.groupService.create(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.dialogRef.close();
          let data = {};
          if (this.oldSection || form.isSection || form.isGeo)
            data = { isSection: this.oldSection ? this.oldSection : form.isSection, grId: form.groupId, isGeo: form.isGeo };
          else
            data = { isPredictive: true };
          this.groupService.sendAction("createGroup", data);
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    } else {
      //edit group
      this.groupService.update(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.dialogRef.close();
          let data;

          if (this.oldSection || form.isSection)
            data = { isSection: this.oldSection ? this.oldSection : form.isSection, grId: form.groupId };
          else
            data = { isPredictive: true };
          this.groupService.sendAction("updateGroup", data);
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/private-dashboard/group/group.dialog.ts